import React, { useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Stack,
    Select,
    Text,
    Box,
    HStack,
} from '@chakra-ui/react'
import Input from './Input';
import { useState } from 'react';
import { FaUser, FaUserAlt } from "react-icons/fa";
import Button from './Button';
import { CreateCategory, CreateStore, CreateUser, UpdateCategoryApi, UpdateStoreApi } from '../Utils/ApiCalls';
import { AiOutlineFieldNumber, AiTwotoneMail, AiFillShopping, AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import { FaShoppingCart } from 'react-icons/fa';
import StoreList from './StoreList';
import MsgCallback from './MsgCallback';



export default function CreateStoreModal({ isOpen, onOpen, onClose, state, storePayload, categoryPayload }) {




    var uuid = (Math.random() + 1).toString(36).substring(7)

    const [Payload, setPayload] = useState(
        {
            name: [
                {
                    id: uuid,
                    name: ""
                },


            ]
        }


    );


    const [CategoryName, setCategoryName] = useState({
        name: [
            {
                id: uuid,
                name: ""
            },

        ]
    }
    )

    const [UpdateStore, setUpdateStore] = useState({
         name: ""
    });
    const [UpdateCategory, setUpdateCategory] = useState({
         name: ""
    });

    // console.log("updateStore", UpdateStore);

    const [errorMsg, setErrorMsg] = useState({
        status: false,
        msg: ""
    });

    const [SuccessMsg, setSuccessMsg] = useState({
        status: false,
        msg: "sdfgvhbnm"
    });


    const [Loading, setLoading] = useState(false);




    const CreateNewStore = async () => {

        try {
            setLoading(true)
            let result = await CreateStore(Payload.name);
            console.log("result", result);
            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Store created successfully"
                })

                setPayload({

                    name: [
                        {
                            id: uuid,
                            name: ""
                        },

                    ]

                })

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,

                    })

                }, 3000);

            } else {

                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })

                }, 5000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);
        }



    }

    const CreateNewCategory = async () => {

        try {
            setLoading(true)
            let result = await CreateCategory(CategoryName.name);
            console.log("result", result);
            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Category created successfully"
                })

                setCategoryName({

                    name: [
                        {
                            id: uuid,
                            name: ""
                        },

                    ]

                })

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,

                    })

                }, 3000);

            } else {

                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })

                }, 5000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);
        }



    }

    const handleStoreUpdate = async ()=>{
        try {
            setLoading(true)
            let result = await UpdateStoreApi(UpdateStore,storePayload.id);
            console.log("result", result);
            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Store Updated successfully"
                })

                setUpdateStore(

                    { name: ""}
               )

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,

                    })

                    onClose()

                }, 3000);

            } else {

                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })

                }, 5000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);

            setTimeout(() => {
                setErrorMsg({
                    status: false,

                })

               

                
            }, 3000);


        }
    }

    const handleCategoryUpdate = async ()=>{
        console.log("UpdateCategory", UpdateCategory)
  
        try {
            setLoading(true)
            let result = await UpdateCategoryApi(UpdateCategory,categoryPayload.id);
            console.log("result", result);
            if (result.status == true) {
                setLoading(false)
                setSuccessMsg({
                    status: true,
                    msg: "Category Updated successfully"
                })

                setUpdateStore(

                    { name: UpdateCategory.name}
               )

             

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,

                    })

                    onClose()
                    
                }, 3000);

            } else {

                setLoading(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

                setTimeout(() => {
                    setErrorMsg({
                        status: false,

                    })

                }, 5000);

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);

            setTimeout(() => {
                setErrorMsg({
                    status: false,

                })

            }, 5000);

        }
    }


   useEffect(() => {
    setUpdateStore({
        name: storePayload.name
   }) 

   setUpdateCategory({
        name: categoryPayload.name
   }) 
   }, [isOpen]);    
    return (



        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
            {
                state == "store" || state == "category" ? (
                    <ModalHeader textTransform="capitalize">Create new {state}</ModalHeader>

                ):(
                    <ModalHeader textTransform="capitalize">{state}</ModalHeader>

                )
            }
                <ModalCloseButton />
                <ModalBody>

                    {
                        state == "store" ? (
                            <Box>
                                <Stack spacing={"15px"}>
                                    <Box display={"flex"} cursor="pointer" justifyContent="flex-end" onClick={() => setPayload({
                                        name: [...Payload.name, {
                                            id: uuid,
                                            name: ""
                                            ,
                                        }]
                                    })}>
                                        <AiOutlinePlus />
                                    </Box>
                                    {
                                        Payload.name.map((item, i) => (
                                            <StoreList data={item} oldItem={Payload.name} Payload={Payload} setPayload={setPayload} key={i} i={i} type="store" />
                                        ))
                                    }

                                </Stack>

                                <Button mt="14px" isLoading={Loading}
                                    disabled={Payload.name[0].name != "" ? false : true}
                                    onClick={CreateNewStore}>Create New Store</Button>

                                <MsgCallback errorMsg={errorMsg} SuccessMsg={SuccessMsg} />
                            </Box>
                        ) : (

                            state == "category" ? (
                                <Box>

                                    <Stack spacing={"15px"}>
                                        <Box display={"flex"} cursor="pointer" justifyContent="flex-end" onClick={() => setCategoryName({
                                            name: [...CategoryName.name, {
                                                id: uuid,
                                                name: ""
                                                ,
                                            }]
                                        })}>
                                            <AiOutlinePlus />
                                        </Box>
                                        {
                                            CategoryName.name.map((item, i) => (
                                                <StoreList data={item} oldItem={CategoryName.name} Payload={CategoryName} setPayload={setCategoryName} key={i} i={i} type="category" />
                                            ))
                                        }
                                    </Stack>

                                    <Button mt="14px" isLoading={Loading}
                                        disabled={CategoryName.name[0].name != "" ? false : true}
                                        onClick={CreateNewCategory}>Create New Category</Button>

                                    <MsgCallback errorMsg={errorMsg} SuccessMsg={SuccessMsg} />
                                </Box>

                            ) : (
                                state == "update Store" ? (
                                    <Box>

                                        <Stack spacing={"15px"}>
                                           
                                        <Input leftIcon={<AiFillShopping />} iconColor="black" labelBg='#fff' label='Store name' id="name" type='text' value={UpdateStore.name} val={UpdateStore.name != "" ? true : false} onChange={(e)=>setUpdateStore({name: e.target.value})} />

                                        </Stack>

                                        <Button mt="14px" isLoading={Loading}
                                        disabled={UpdateStore.name != "" ? false : true}  
                                            onClick={handleStoreUpdate}>Update Store</Button>

                                        <MsgCallback errorMsg={errorMsg} SuccessMsg={SuccessMsg} />
                                    </Box>

                                ) : (
                                    <Box>

                                        <Stack spacing={"15px"}>
                                        <Input leftIcon={<AiFillShopping />} iconColor="black" labelBg='#fff' label='Store name' id="name" type='text' value={UpdateCategory.name} val={UpdateCategory.name != "" ? true : false} onChange={(e)=>setUpdateCategory({name: e.target.value})} />

                                        </Stack>

                                        <Button mt="14px" isLoading={Loading}
                                        disabled={UpdateCategory.name != "" ? false : true} 
                                            onClick={handleCategoryUpdate}>Update Category</Button>

                                        <MsgCallback errorMsg={errorMsg} SuccessMsg={SuccessMsg} />
                                    </Box>

                                )
                            )
                        )
                    }




                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>

    )
}
